import { Lock } from 'lucide-react';
import { Dialog } from './Dialog';

interface AccessDeniedDialogProps {
  isOpen: boolean;
  onClose: () => void;
  action?: string;
}

export function AccessDeniedDialog({ isOpen, onClose, action }: AccessDeniedDialogProps) {
  return (
    <Dialog isOpen={isOpen} onClose={onClose}>
      <div className="flex flex-col items-center text-center pt-2">
        <div className="w-14 h-14 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center mb-4">
          <Lock className="h-7 w-7 text-red-500" />
        </div>
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
          Access Restricted
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">
          {action
            ? <><strong>{action}</strong> is restricted to administrators.</>
            : <>This action is restricted to administrators.</>}
        </p>
        <p className="text-xs text-gray-500 dark:text-gray-500 mb-6">
          Contact your administrator if you need access to this feature.
        </p>
        <button
          onClick={onClose}
          className="px-6 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-md text-sm font-medium"
        >
          OK
        </button>
      </div>
    </Dialog>
  );
}
